import { render, staticRenderFns } from "./CDropdown.vue?vue&type=template&id=e2a2d2ca&"
import script from "./CDropdown.vue?vue&type=script&lang=js&"
export * from "./CDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports